<div
    class="deal-card bg-white cursor-pointer hover:shadow-2"
    [dealActivate]="baseDeal"
    [user]="user"
>
    <div class="relative">
        <img
            [src]="baseDeal.coverImage.src"
            [srcset]="baseDeal.coverImage.srcset"
            [sizes]="baseDeal.coverImage.sizes"
            [alt]="
                baseDeal.coverImage.alt || baseDeal.destination.cityName + ' travel'
            "
            loading="lazy"
            decoding="async"
            class='w-full deal-image-default border-round-top'
            style="object-fit: cover; display: block"
        />

        <p-tag
            *ngIf="
                baseDeal.destination.isDreamDestination &&
                !baseDeal.isExpired
            "
            severity="success"
            styleClass="absolute top-0 left-0 mt-3 ml-3 text-black"
            value="Dream Destination"
            [rounded]="true"
        >
            <i class="ph-fill ph-heart mr-1 text-red-500"></i>
        </p-tag>
        <p-tag
            *ngIf="baseDeal.isExpired"
            severity="success"
            styleClass="absolute top-0 left-0 mt-3 ml-3 text-black"
            value="Expired"
            [rounded]="true"
        >
            <i class="ph ph-calendar-x mr-1"></i>
        </p-tag>
        <p-tag
            *ngIf="!canView"
            severity="success"
            styleClass="absolute top-0 right-0 mt-3 mr-3 border-circle"
            [style]="{ width: '30px', height: '30px' }"
        >
            <i class="ph-fill ph-lock text-xl"></i>
        </p-tag>
    </div>

    <div class="flex flex-column gap-2 pt-3 px-3 pb-3 border-round-bottom border-1 border-top-none surface-border">
        <h5 class="m-0 font-bold single-line-ellipsis">
            {{ baseDeal.destination.cityName }},
            <span *ngIf="baseDeal.destination.stateName; else country">
                {{ baseDeal.destination.stateName }}</span
            >
            <ng-template #country>
                {{ baseDeal.destination.country }}</ng-template
            >
            <!-- ({{ baseDeal.destination.iata }}) -->
        </h5>

        <h5 class="m-0 font-bold">
            ${{ baseDeal.priceMin }}
            <span
                class="text-base line-through font-medium vertical-align-middle"
                >${{ baseDeal.standardPrice }}</span
            >
        </h5>
        <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center gap-4">
            <div class="flex align-items-center gap-2">
                <i class="text-xl text-color-secondary ph ph-air-traffic-control"></i>
                <p class="m-0 text-lg">{{ baseDeal.departure.iata }}</p>
            </div>
            <div class="flex align-items-center gap-2">
                <i class="text-xl text-color-secondary ph ph-chair"></i>
                <p class="m-0 text-lg">{{ baseDeal.flightClass | flightClassLabel }}</p>
            </div>
        </div>
        </div>
        <!-- <div class="flex justify-content-end align-items-center mb-0 mt-1 gap-1">
        <h6 class="m-0 text-md cursor-pointer">View Details</h6>
        <i class="ph ph-caret-circle-right text-color-primary"></i>
    </div> -->
    </div>
</div>
